import { useAuthToken } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import SlateKit from '@tribeplatform/slate-kit'
import { SlateKitProvider } from '@tribeplatform/slate-kit/components'

import { SLATE_COMPONENTS } from '../../../slate-components'
import { Preview } from '../../CanaryPageBuilder/Preview'
import { useThemePreviewContext } from './ThemePreviewContext'

export const EditorPreview = () => {
  const { state, pages } = useThemePreviewContext()
  const slateKit = new SlateKit()
  slateKit.registerComponents(SLATE_COMPONENTS as any)
  const {
    data: { network, member },
  } = useAuthToken({
    useQueryOptions: {
      // this is here to prevent the whole page from re-rendering
      notifyOnChangeProps: ['data'],
    },
  })

  return (
    <SlateKitProvider
      kit={slateKit}
      context={{
        network,
        visitor: member,
      }}
    >
      <div className="bg-main-100 h-full p-8">
        <div className="space-y-4">
          <PreviewHeader />
          <Preview state={state} pages={pages} />
        </div>
      </div>
    </SlateKitProvider>
  )
}

const PreviewHeader = () => {
  return (
    <div className="flex space-between items-center justify-between">
      <div className="w-1/3" />
      <div className="w-1/3" />
      <div className="w-1/3 flex justify-end">
        <Button disabled>Save changes</Button>
      </div>
    </div>
  )
}
